/* global fbq */
import resultData from '../../data/result.json'
import AppStore from '../../store/AppStore.js'

export default {
  computed: {
    imgDynamic () {
      return /^http/.test(this.img) ? this.data.img : require('../../img' + this.data.img)
    }
  },
  data () {
    return {
      store: AppStore.state,
      data: resultData[AppStore.state.result]
    }
  },
  mounted () {
    fbq('track', 'ViewContent')
    fbq('track', 'CompleteRegistration')
  },
  methods: {
    goToArchivist () {
      window.location.href = '//archivi.st'
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/result/result.js